// extracted by mini-css-extract-plugin
export var projects = "projects-module--projects--jK09p";
export var title = "projects-module--title--33hge";